import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import "./style.css";
import { useEffect, useState } from "react";
import { GetAllMP_MR_Item } from "../../../Redux/Reducers/AdvertisingAndMediaPlanForTheProject/DropDownForItems";
import AddAdvertising from "../../../Services/ProjectInformationPage/AdvertisingAndMediaPlanForTheProject/AddAdvertisingAndMediaPlanForTheProject";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import UpdateAdvertising from "../../../Services/ProjectInformationPage/AdvertisingAndMediaPlanForTheProject/UpdateAdvertisingAndMediaPlanForTheProject";
import {
  GetOneAdvertisingAndMediaPlanForTheProject,
  restValidationAdvertisingAndMediaPlan,
  ValidateMP_MarketingResourcesAndPublications,
} from "../../../Redux/Reducers/AdvertisingAndMediaPlanForTheProject/indexOne";
// import AddAdvertising from "../../../Services/ProjectInformationPage/AdvertisingAndMediaPlanForTheProject/AddAdvertisingAndMediaPlanForTheProject";
import $ from "jquery";
import Swal from "sweetalert2";

const AddEdit = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownItem: state.DropDownItem.DropDownItem,
      AdvertisingAndMediaPlanForTheProject:
        state.AdvertisingAndMediaPlanForTheProject
          .AdvertisingAndMediaPlanForTheProject,
      OneAdvertisingAndMediaPlanForTheProject:
        state.OneAdvertisingAndMediaPlanForTheProject
          .OneAdvertisingAndMediaPlanForTheProject,
      OneAdvertisingAndMediaPlanForTheProjectloading:
        state.OneAdvertisingAndMediaPlanForTheProject
          .loadingOneAdvertisingAndMediaPlanForTheProject,
      OneAdvertisingAndMediaPlanForTheProjectValidate:
        state.OneAdvertisingAndMediaPlanForTheProject
          .OneAdvertisingAndMediaPlanForTheProjectValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  //console.log(state.OneAdvertisingAndMediaPlanForTheProject, "one");
  const [MP_MR_Item, setMP_MR_Item] = useState([
    {
      DropDownItem: state.DropDownItem?.mP_MR_ItemId,
    },
  ]);

  const [AdvertisingList, setAdvertisingList] = useState({
    mP_MarketingResourcesAndPublicationsId:
      state.OneAdvertisingAndMediaPlanForTheProject
        ?.mP_MarketingResourcesAndPublicationsId,
    mP_MR_ItemId: state.OneAdvertisingAndMediaPlanForTheProject?.mP_MR_ItemId,
    itemNameAnother:
      state.OneAdvertisingAndMediaPlanForTheProject?.itemNameAnother,
    descriptionContentObjective:
      state.OneAdvertisingAndMediaPlanForTheProject
        ?.descriptionContentObjective,
    quantity: state.OneAdvertisingAndMediaPlanForTheProject?.quantity,
    aP_AdvertisingAndMediaPlanId:
      state.AdvertisingAndMediaPlanForTheProject.aP_AdvertisingAndMediaPlanId,
    mediaAndAdvertisingPlanExplanation:
      state.AdvertisingAndMediaPlanForTheProject
        .mediaAndAdvertisingPlanExplanation,
  });
  //console.log(
  //   state.AdvertisingAndMediaPlanForTheProject.aP_AdvertisingAndMediaPlanId,
  //   "kk"
  // );
  //console.log(
  //   state.OneAdvertisingAndMediaPlanForTheProject,
  //   "OneAdvertisingAndMediaPlanForTheProject"
  // );

  //console.log(state.DropDownItem, "rrr");
  useEffect(() => {
    dispatch(GetAllMP_MR_Item());
  }, []);
  //function to add comma inside the numbers
  const numberWithCommas = (x) => {
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // function for add to tabel
  const AddAdds = async () => {
    // check validation
    const validationList = await dispatch(
      ValidateMP_MarketingResourcesAndPublications({
        mP_MR_ItemId: AdvertisingList.mP_MR_ItemId,
        itemNameAnother: AdvertisingList.itemNameAnother,
        descriptionContentObjective:
          AdvertisingList.descriptionContentObjective,
        quantity: AdvertisingList.quantity,
        mediaAndAdvertisingPlanExplanation:
          AdvertisingList.mediaAndAdvertisingPlanExplanation,
      })
    );
    //if validation ends add to table
    if (validationList.payload.length === 0) {
      await AddAdvertising(
        AdvertisingList.mP_MR_ItemId,
        AdvertisingList.itemNameAnother,
        AdvertisingList.descriptionContentObjective,
        AdvertisingList.quantity,
        AdvertisingList.mediaAndAdvertisingPlanExplanation,
        AdvertisingList.aP_AdvertisingAndMediaPlanId
      );
      //to close popup
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    dispatch(restValidationAdvertisingAndMediaPlan());
  }, []);
  // function for update
  const UpdateAdd = async () => {
    const validationList = await dispatch(
      ValidateMP_MarketingResourcesAndPublications({
        mP_MR_ItemId: AdvertisingList.mP_MR_ItemId,
        itemNameAnother: AdvertisingList.itemNameAnother,
        descriptionContentObjective:
          AdvertisingList.descriptionContentObjective,
        quantity: AdvertisingList.quantity,
        mediaAndAdvertisingPlanExplanation:
          AdvertisingList.mediaAndAdvertisingPlanExplanation,
      })
    );
    //if validation ends update on row

    if (validationList.payload.length === 0) {
      await UpdateAdvertising({
        mP_MR_ItemId: AdvertisingList.mP_MR_ItemId,
        itemNameAnother: AdvertisingList.itemNameAnother,
        descriptionContentObjective:
          AdvertisingList.descriptionContentObjective,
        quantity: AdvertisingList.quantity,
        aP_AdvertisingAndMediaPlanId:
          AdvertisingList.aP_AdvertisingAndMediaPlanId,
        mP_MarketingResourcesAndPublicationsId:
          AdvertisingList.mP_MarketingResourcesAndPublicationsId,
        mediaAndAdvertisingPlanExplanation:
          AdvertisingList.mediaAndAdvertisingPlanExplanation,
      });
      //close popup
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      //to refresh table after action
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    if (props != null) {
      // If `props` is not null, dispatch an action to fetch data for
      // a specific Advertising and Media Plan using the provided ID.
      dispatch(
        GetOneAdvertisingAndMediaPlanForTheProject(
          props.MarketingResourcesAndPublicationsId
        )
      );
    }
  }, [props.MarketingResourcesAndPublicationsId]);
  // Dependency array: This effect re-runs when `props.MarketingResourcesAndPublicationsId` changes.

  useEffect(() => {
    if (
      !state.OneAdvertisingAndMediaPlanForTheProjectloading &&
      Object.keys(props).length != 0
    ) {
      // If the loading state for `OneAdvertisingAndMediaPlanForTheProject` is false
      // and `props` is not empty, update `AdvertisingList` with the fetched data.
      setAdvertisingList({
        ...state.OneAdvertisingAndMediaPlanForTheProject,
      });
    } else {
      // Otherwise, set `AdvertisingList` with default values, including:
      // null for some fields and an ID from `AdvertisingAndMediaPlanForTheProject`.
      setAdvertisingList({
        mP_MR_ItemId: null,
        itemNameAnother: null,
        descriptionContentObjective: null,
        quantity: null,
        mediaAndAdvertisingPlanExplanation:null,
        aP_AdvertisingAndMediaPlanId:
          state.AdvertisingAndMediaPlanForTheProject
            .aP_AdvertisingAndMediaPlanId,
      });
    }
  }, [state.OneAdvertisingAndMediaPlanForTheProject]);
  // Dependency array: This effect re-runs when `state.OneAdvertisingAndMediaPlanForTheProject` changes.

  const shouldDisableFields = !(
    //[,]
    // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
    (
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    )
  );

  // Use Effect for make itemNameAnother null if change mP_MR_ItemId to not (أخرى)
  useEffect(() => {
    if (AdvertisingList?.mP_MR_ItemId !== 11) {
      setAdvertisingList((prev) => ({
        ...prev,
        itemNameAnother: null,
      }));
    }
  }, [AdvertisingList?.mP_MR_ItemId]);

  return (
    <>
      {!state.OneAdvertisingAndMediaPlanForTheProjectloading ? (
        <>
          <div className="AddEdite">
            <AllDropDownsAHSF
              fieldsName="Item"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownItem}
              KeyText={"itemNameAr"}
              KeyValue={"mP_MR_ItemId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setAdvertisingList({
                  ...AdvertisingList,
                  mP_MR_ItemId: Number(e.target.value),
                });
              }}
              defaultValue={AdvertisingList.mP_MR_ItemId}
              showValidationMessage={
                state.OneAdvertisingAndMediaPlanForTheProjectValidate
                  ? state.OneAdvertisingAndMediaPlanForTheProjectValidate.includes(
                      "Item"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {AdvertisingList?.mP_MR_ItemId == 11 && (
              <InputAHSF
                fieldsName="AnotherName"
                show={true}
                disabled={shouldDisableFields}
                onChange={(e) => {
                  setAdvertisingList({
                    ...AdvertisingList,
                    itemNameAnother: e.target.value,
                  });
                }}
                defaultValue={
                  state.OneAdvertisingAndMediaPlanForTheProject?.itemNameAnother
                }
                showValidationMessage={
                  state.OneAdvertisingAndMediaPlanForTheProjectValidate
                    ? state.OneAdvertisingAndMediaPlanForTheProjectValidate.includes(
                        "AnotherName"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
            )}

            <TextAreaAHSF
              fieldsName="Description"
              show={true}
              disabled={shouldDisableFields}
              defaultValue={
                state.OneAdvertisingAndMediaPlanForTheProject
                  ?.mediaAndAdvertisingPlanExplanation
              }
              onChange={(e) => {
                setAdvertisingList({
                  ...AdvertisingList,
                  mediaAndAdvertisingPlanExplanation: e.target.value,
                });
              }}
              showValidationMessage={
                state.OneAdvertisingAndMediaPlanForTheProjectValidate
                  ? state.OneAdvertisingAndMediaPlanForTheProjectValidate.includes(
                      "NeedForMediaAndAdvertising"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <TextAreaAHSF
              fieldsName="objectiveName"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setAdvertisingList({
                  ...AdvertisingList,
                  descriptionContentObjective: e.target.value,
                });
              }}
              defaultValue={AdvertisingList.descriptionContentObjective}
              showValidationMessage={
                state.OneAdvertisingAndMediaPlanForTheProjectValidate
                  ? state.OneAdvertisingAndMediaPlanForTheProjectValidate.includes(
                      "Description"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
              fieldsName="Quantity"
              show={true}
              disabled={shouldDisableFields}
              comma={true}
              onChange={(e) => {
                setAdvertisingList({
                  ...AdvertisingList,
                  quantity: parseFloat(e.target.value),
                });
              }}
              defaultValue={numberWithCommas(
                state.OneAdvertisingAndMediaPlanForTheProject?.quantity
              )}
              showValidationMessage={
                state.OneAdvertisingAndMediaPlanForTheProjectValidate
                  ? state.OneAdvertisingAndMediaPlanForTheProjectValidate.includes(
                      "Quantity"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit" ? UpdateAdd() : AddAdds();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <LoaderAHSF
            // show={
            //   state.SubSectors.loadingaI_SecondarySectors ||
            //   state.dropDownApplicationInformationLoding.loadingSubSector
            // }
            />
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.OneAdvertisingAndMediaPlanForTheProjectloading} />
    </>
  );
};
export default AddEdit;
